export enum UrlQueryParameters {
  EnableCategoriesPage = 'EnableCategoriesPage',
  FullWidth = 'fullWidth',
}
